'use strict';

var loqate = require('./loqate');
var debounce = require('../util/debounce');
var loqateAddress = require('./loqateAddress');

var li;
var next;
var liSelected;
var index = -1;
var len;

var shippingAddressOneLoqate = '#shippingAddressOneLoqate';
var dropdownItem = '.dropdown-item';
var selectedColor = 'selected-color';
var dataHashAddress = 'data-hash-address';
var addressRight = '.address-right';
var addressLeft = '.address-left';
var searchInner = '.search-inner';
var manualBypassAddressValidation = '#manualBypassAddressValidation';
/**
 * Scroll through container on key up and down
 * @param {string} $container - active container
 * @param {Object} $selectedElement - selected element
 * @param {Object} direction - direction
 */
function handleKeyUpAndDown($container, $selectedElement, direction) {
    if (direction === 'up') {
        var containerTopUp = $container.scrollTop();
        var itemTopUp = $selectedElement.position().top + containerTopUp;
        if (itemTopUp < containerTopUp) {
            $container.scrollTop(itemTopUp);
        }
    }
    if (direction === 'down') {
        var containerTop = $container.scrollTop();
        var containerBottom = containerTop + $container.height();
        var itemTop = $selectedElement.position().top + containerTop;
        var itemBottom = itemTop + $selectedElement.outerHeight();
        if (itemBottom > containerBottom) {
            $container.scrollTop(itemBottom - $container.height());
        }
    }
}
/**
 * Reset the state that keeps track of the selected suggestion item.
 */
function resetSelectedItem() {
    liSelected = null;
    index = -1;
}
/**
     * Close the dropdown menu and clear/reset all state.
     */
function clearAndExitDropdown() {
    if ($('[data-testid="loqate-address-suggestions"]').data('disable-field-clear') !== true) {
        $(shippingAddressOneLoqate).val('');
        $(manualBypassAddressValidation).val('true');
    }
    loqate.removeAddressSuggestions();
    resetSelectedItem();
}

/**
     * arrow down keyboard event
     * @param {string} $addressSectionDown - address main section container
     * @param {Object} $containerDown - address inner section element
     */
function arrowDown($addressSectionDown, $containerDown) {
    li = $addressSectionDown.find(dropdownItem);
    len = li.length - 1;
    index += 1;
    if (liSelected) {
        liSelected.removeClass(selectedColor);
        next = li.eq(index);
        if (next !== undefined && index <= len) {
            liSelected = next;
            liSelected.addClass(selectedColor);
            $(shippingAddressOneLoqate).val(liSelected.attr(dataHashAddress));
            handleKeyUpAndDown($containerDown, liSelected, 'down');
        } else {
            index -= 1;
            liSelected = li.last().addClass(selectedColor);
            $(shippingAddressOneLoqate).val(liSelected.attr(dataHashAddress));
        }
    } else {
        liSelected = li.eq(index).addClass(selectedColor);
        $(shippingAddressOneLoqate).val(liSelected.attr(dataHashAddress));
    }
}

/**
     * arrow up keyboard event
     * @param {string} $addressSectionUp - address main section container
     * @param {Object} $containerUp - address inner section element
     */
function arrowUp($addressSectionUp, $containerUp) {
    li = $addressSectionUp.find(dropdownItem);
    len = li.length - 1;
    if (liSelected) {
        liSelected.removeClass(selectedColor);
        index -= 1;
        next = li.eq(index);
        if (next !== undefined && index >= 0) {
            liSelected = next;
            liSelected.addClass(selectedColor);
            $(shippingAddressOneLoqate).val(liSelected.attr(dataHashAddress));
            handleKeyUpAndDown($containerUp, liSelected, 'up');
        } else {
            index = 0;
            liSelected = li.first().addClass(selectedColor);
            $(shippingAddressOneLoqate).val(liSelected.attr(dataHashAddress));
        }
    } else {
        liSelected = li.first().addClass(selectedColor);
        $(shippingAddressOneLoqate).val(liSelected.attr(dataHashAddress));
    }
}

/**
     * tab keyboard event
     */
function tab() {
    if (liSelected && !loqate.isLoqateContainer(liSelected)) {
        loqateAddress.fillShippingAddress(liSelected);
    }
}

/**
     * enter keyboard event
     * @param {Object} e - the event
     */
function enter(e) {
    e.preventDefault();
    if (loqate.isLoqateContainer(liSelected)) {
        loqateAddress.getAddressSuggestions(liSelected.attr('data-id'), liSelected.attr('data-address'));
        resetSelectedItem();
    } else if (liSelected) {
        loqateAddress.fillShippingAddress(liSelected);
    }
}

/**
     * escape keyboard event
     */
function escape() {
    clearAndExitDropdown();
}

/**
     * shift tab keyboard event
     */
function shiftTab() {
    if (liSelected && !loqate.isLoqateContainer(liSelected)) {
        loqateAddress.fillShippingAddress(liSelected);
    } else {
        clearAndExitDropdown();
    }
}

/**
 * if the form goes into manual address entry, this keydown event
 * is removed in handleManualAddress
 */
function keyDownEvent() {
    var debounceSuggestions = debounce(loqateAddress.getAddressSuggestions, 200);

    // if the form goes into manual address entry, this keydown event
    // is removed in handleManualAddress
    $(shippingAddressOneLoqate).on('keydown', function (event) {
        var $addressSection = loqate.isContainerMode()
            ? $(addressRight)
            : $(addressLeft);
        var container = $addressSection.find(searchInner);
        var eventKey = event.key;
        var shiftKey = event.shiftKey;
        if (shiftKey && eventKey === 'Tab') {
            shiftTab();
            return;
        }
        if (shiftKey) {
            return;
        }
        if ((event.ctrlKey || event.metaKey) && (eventKey === 'v' || eventKey === 'V')) {
            $(manualBypassAddressValidation).val('true');
        }
        switch (eventKey) {
            case 'ArrowDown':
            case 'Down':
                arrowDown($addressSection, container);
                break;
            case 'ArrowUp':
            case 'Up':
                arrowUp($addressSection, container);
                break;
            case 'Enter':
                enter(event);
                break;
            case 'Tab':
                tab();
                break;
            case 'Escape':
                escape();
                break;
            default:
                debounceSuggestions();
                resetSelectedItem();
        }
    });
}

/**
 * turn off locate when we want to use a manual address
 * by removing the keydown event on #shippingAddressOneLoqate
 */
function initLoqate() {
    // loqate.initInputFields();
    loqate.initEnterManualAddressEvents();
    loqate.initEnterAddressVerificationEvents();

    if ($('#addressSuggestionUrl').val()) {
        $(shippingAddressOneLoqate).attr('autocomplete', 'off');
        $(shippingAddressOneLoqate).attr('aria-live', 'assertive');
        loqate.updateNeedsVerification(false);
    }

    $(document).on('keydown', '#enterAddressManually', function (event) {
        if (event.key === 'Tab' && !event.shiftKey) {
            clearAndExitDropdown();
        }
    });
    // if the form goes into manual address entry, this keydown event
    // is removed in handleManualAddress
    keyDownEvent();

    $(document).on('click', function () {
        // This is so that the menu closes when you click outside of it.
        // Elements within the menu provide more specific event handlers
        // and stop propagation
        if (loqate.isDropdownMenuOpen()) {
            shiftTab();
        }
    });
    $(document).on('click', '#backToResult', function (event) {
        event.stopPropagation();
        $(addressRight).removeClass('d-block').addClass('d-none');
        $(addressLeft).removeClass('d-none').addClass('d-block');
        var $suggestions = $('.dropdown-address-suggestions');
        $suggestions.find(dropdownItem).removeClass(selectedColor);
        $suggestions.find(addressRight).find(searchInner).empty();
        var $dropdownHeader = $suggestions.find('.dropdown-header');
        var addressSuggestionLabel = $dropdownHeader.attr('data-address-suggestion-label');
        $dropdownHeader.empty().text(addressSuggestionLabel);
        $(shippingAddressOneLoqate)[0].focus();
        $('.search-result').removeClass('search-right-animation').attr('data-suggestion-mode', 'default');
        $(addressLeft).find(searchInner).scrollTop(0);
        resetSelectedItem();
    });
    $('.dropdown-address-suggestions').not('.disabled').on('click', dropdownItem, function (event) {
        event.stopPropagation();
        var $listItem = $(this);
        if (loqate.isLoqateContainer($listItem)) {
            $(shippingAddressOneLoqate).val($listItem.attr(dataHashAddress));
            loqateAddress.getAddressSuggestions(
                $listItem.attr('data-id'),
                $listItem.attr('data-address')
            );
            resetSelectedItem();
        } else {
            loqateAddress.fillShippingAddress($listItem);
        }
    });
    // This method is designed to address a specific issue encountered when using a Windows screen reader.
    $(document).on('focusin', '.shipping-address', function (event) {
        var ignoreElementIds = [
            'backToResult',
            'shippingAddressOneLoqate',
            'enterAddressManually'
        ];
        if (loqate.isDropdownMenuOpen() && !ignoreElementIds.includes(event.target.id)) {
            loqate.removeAddressSuggestions();
            resetSelectedItem();
        }
    });

    $(document).on('hide.bs.modal', '#addressVerificationModal', function () {
        // track the close modal event unless the user is clicking on the save and continue button
        if (!$(document.activeElement).hasClass('select-address-btn')) {
            $(document).trigger('loqate:address-verification-modal-close'); // tracking
        }
    });
}
module.exports = {
    initLoqate: initLoqate
};
